

import AlertHandler from "../../../../assets/js/modules/alertHandler";
import { Modal } from 'bootstrap';


function productProcuremenForm() {
    const orderQuantityField = document.getElementById('id_order_quantity');
    const receivedQuantityField = document.getElementById('id_received_quantity');
    const statusField = document.getElementById('id_status');
    const form = document.getElementById('productProcuremenFormUpdate');
    const submitButton = document.getElementById('submit-id-submit');
    
    function checkQuantities(e) {
        const orderQty = parseFloat(orderQuantityField?.value) || 0;
        const receivedQty = parseFloat(receivedQuantityField?.value) || 0;
        if (submitButton) submitButton.disabled = false;
    
        if (receivedQty > orderQty) {
            AlertHandler.showAlert('Die erhaltene Menge kann nicht größer sein als die Bestellmenge!', 'danger');
            if (submitButton) submitButton.disabled = true;
        }
    
        if (statusField.value === 'ABGESCHLOSSEN' && receivedQty < orderQty) {
            AlertHandler.showAlert('Bei ABGESCHLOSSEN darf die erhaltene Menge nicht kleiner sein als die Bestellmenge!', 'danger');
            if (submitButton) submitButton.disabled = true;
        }
    
        if (statusField.value === 'ABGESCHLOSSEN' && !receivedQty) {
            AlertHandler.showAlert('Bei ABGESCHLOSSEN muss eine Menge eingegeben werden!', 'danger');
            if (submitButton) submitButton.disabled = true;
        }
    
        if (statusField.value === 'TEILLIEFERUNG' && !receivedQty) {
            AlertHandler.showAlert('Bei TEILLIEFERUNG muss eine Menge eingegeben werden!', 'danger');
            if (submitButton) submitButton.disabled = true;
        }
    
        if (statusField.value === 'TEILLIEFERUNG' && receivedQty >= orderQty) {
            AlertHandler.showAlert('Bei vollständiger Lieferung sollte der Status auf ABGESCHLOSSEN gesetzt werden!', 'danger');
            if (submitButton) submitButton.disabled = true;
        }
 
        if (statusField.value === 'STORNIERT') {
            const disabledFields = form.querySelectorAll('input[disabled], select[disabled], textarea[disabled]');
            disabledFields.forEach(field => {
                if (field.name !== 'status') {
                    field.disabled = false;
                }
            });
            const fieldsToMakeReadonly = ['product', 'supplier', 'order_quantity', 'unit_price', 'order_date', 'expected_delivery', 'actual_delivery', 'notes', 'batch_number', 'storage_location'];
            fieldsToMakeReadonly.forEach(fieldName => {
                const field = document.getElementById(`id_${fieldName}`);
                if (field) {
                    field.readOnly = true;
                }
            });
            if (receivedQuantityField) {
                receivedQuantityField.readOnly = false;
                receivedQuantityField.disabled = false;
            }

            AlertHandler.showAlert('Stornierung aktiviert: Geben Sie die Menge ein, die aus dem Lager entfernt werden soll.', 'warning');
            return;
        }
    }
    

    
    receivedQuantityField?.addEventListener('change', checkQuantities);
    statusField?.addEventListener('change', checkQuantities);
    form?.addEventListener('submit', checkQuantities);
    }
    
    export default productProcuremenForm;